import {
  AppointmentClientView,
  AppointmentClientViewDto,
  AppointmentDetail,
  AppointmentDetailDto,
  AppointmentListItem,
  AppointmentListItemDto
} from './appointments.models';

export function mapAppointmentListItem(
  dto: AppointmentListItemDto
): AppointmentListItem
{
  return {
    id: dto.id,
    clinicId: dto.clinicId,
    clientId: dto.clientId,
    procedureTypeId: dto.procedureTypeId,
    primarySlotId: dto.primarySlotId,
    deviceId: dto.deviceId,
    specialistUserId: dto.specialistUserId ?? null,
    status: dto.status,
    confirmationRequired: dto.confirmationRequired,
    clientChangesLocked: dto.clientChangesLocked ?? false,
    confirmedAt: dto.confirmedAt,
    checkedInAt: dto.checkedInAt ?? null,
    checkedInByUserId: dto.checkedInByUserId ?? null,
    finishedAt: dto.finishedAt ?? null,
    finishedByUserId: dto.finishedByUserId ?? null,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
    slotIds: Array.isArray(dto.slotIds)
      ? dto.slotIds.filter((slotId): slotId is string => typeof slotId === 'string')
      : [],
    clinicLabel: typeof dto.clinicLabel === 'string' ? dto.clinicLabel : undefined,
    clinicTimeZone: typeof dto.clinicTimeZone === 'string' ? dto.clinicTimeZone : undefined,
    deviceLabel: typeof dto.deviceLabel === 'string' ? dto.deviceLabel : undefined,
    procedureTypeLabel: typeof dto.procedureTypeLabel === 'string' ? dto.procedureTypeLabel : undefined,
    clientLabel: typeof dto.clientLabel === 'string' ? dto.clientLabel : undefined,
    specialistLabel: typeof dto.specialistLabel === 'string' ? dto.specialistLabel : undefined,
    primarySlotStartAt: typeof dto.primarySlotStartAt === 'string' ? dto.primarySlotStartAt : null,
    primarySlotEndAt: typeof dto.primarySlotEndAt === 'string' ? dto.primarySlotEndAt : null,
    appointmentStartAt: typeof dto.appointmentStartAt === 'string' ? dto.appointmentStartAt : null,
    appointmentEndAt: typeof dto.appointmentEndAt === 'string' ? dto.appointmentEndAt : null,
    slotCount: Number.isFinite(dto.slotCount) ? dto.slotCount : undefined,
  };
}

export function mapAppointmentClientView(
  dto: AppointmentClientViewDto,
): AppointmentClientView
{
  return {
    id: dto.id,
    status: dto.status,
    clinicLabel: typeof dto.clinicLabel === 'string' ? dto.clinicLabel : null,
    clinicTimeZone: typeof dto.clinicTimeZone === 'string' ? dto.clinicTimeZone : null,
    procedureTypeLabel: typeof dto.procedureTypeLabel === 'string' ? dto.procedureTypeLabel : null,
    specialistLabel: typeof dto.specialistLabel === 'string' ? dto.specialistLabel : null,
    appointmentStartAt: typeof dto.appointmentStartAt === 'string' ? dto.appointmentStartAt : null,
    appointmentEndAt: typeof dto.appointmentEndAt === 'string' ? dto.appointmentEndAt : null,
    primarySlotStartAt: typeof dto.primarySlotStartAt === 'string' ? dto.primarySlotStartAt : null,
    primarySlotEndAt: typeof dto.primarySlotEndAt === 'string' ? dto.primarySlotEndAt : null,
    slotCount: Number.isFinite(dto.slotCount) ? dto.slotCount : 0,
    clientChangesLocked: dto.clientChangesLocked === true,
    actions: {
      canConfirm: dto.actions?.canConfirm === true,
      canCancel: dto.actions?.canCancel === true,
      canEdit: dto.actions?.canEdit === true,
      lockedReason: typeof dto.actions?.lockedReason === 'string' ? dto.actions.lockedReason : null,
    },
  };
}

export function mapAppointmentDetail(
  dto: AppointmentDetailDto,
): AppointmentDetail
{
  const base = mapAppointmentListItem(dto);

  return {
    ...base,
    procedureTypeLabel: typeof dto.procedureTypeLabel === 'string' ? dto.procedureTypeLabel : undefined,
    clientLabel: typeof dto.clientLabel === 'string' ? dto.clientLabel : undefined,
    specialistLabel: typeof dto.specialistLabel === 'string' ? dto.specialistLabel : undefined,
    primarySlot: dto.primarySlot && typeof dto.primarySlot.id === 'string'
      ? {
          id: dto.primarySlot.id,
          startTime: dto.primarySlot.startTime,
          endTime: dto.primarySlot.endTime,
        }
      : null,
    slotCount: Number.isFinite(dto.slotCount) ? dto.slotCount : base.slotIds.length,
  };
}
